// extracted by mini-css-extract-plugin
export default {"swatch":"swatch_q6DGb"};